import styled from 'styled-components/macro';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import plusIcon from 'assets/icons/plus.svg';

export const SelectedTagWrapper = styled(DropdownMenu.Trigger)`
  box-sizing: border-box;
  position: relative;
  border: none;

  min-width: 32px;
  max-width: fit-content;
  height: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 8px;

  background-color: #f5f5fb;
  border-radius: 10px;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

export const StyledPortal = styled(DropdownMenu.Portal)<{
  // во избежание конфликтов с TS 4.9.5
  onClick: Function;
}>`
  //z-index: 9999;
  //width: 100vw;
  //height: 100vh;
  //background-color: #8888ff;
  //opacity: 0.5;
  //pointer-events: none;
`;

export const TagsList = styled(DropdownMenu.Content)`
  //position: absolute;
  width: 160px;
  //bottom: 30px;
  //left: 0;
  padding: 12px 0;

  background-color: #ffffff;
  box-shadow: 0 3px 8px rgba(7, 31, 59, 0.06), 0 8px 24px rgba(0, 32, 51, 0.12);
  border: 1px solid #d8deeb;
  border-radius: 8px;

  z-index: 99999;
`;

export const TagListItem = styled(DropdownMenu.Item)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 17px;

  &:hover {
    background-color: #eff1f5;
    cursor: pointer;
    outline: none;
  }
`;

export const SelectTagSpan = styled.span`
  padding: 0 17px;
  color: #8495a9;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
`;

export const IconAdd = styled.img.attrs({
  src: plusIcon,
})`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;
